/** 地区分桶：按时区粗粒度归类（副榜用），无法判定归 global。 */
export function detectRegion(): string {
  let tz = '';
  try {
    tz = Intl.DateTimeFormat().resolvedOptions().timeZone ?? '';
  } catch {
    tz = '';
  }
  if (tz.startsWith('Asia/')) return 'asia';
  if (tz.startsWith('Europe/')) return 'eu';
  if (tz.startsWith('America/')) return 'na';
  if (tz.startsWith('Australia/') || tz.startsWith('Pacific/')) return 'oceania';
  if (tz.startsWith('Africa/')) return 'africa';
  return 'global';
}
